import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import MainLayout from "../layouts/MainLayout";
import UserTable from "../components/UserTable";
import ClientPagination from "../components/ClientPagination";
import useApi from "../utils/useApi";
import { useLoading } from "../context/LoadingContext";
import { Modal } from "bootstrap";
import ConfirmPasswordModal from "../components/ConfirmPasswordModal";
import CreateUserModal from "../components/CreateUserModal";
import EditUserModal from "../components/EditUserModal";

const BrowseUsers = () => {
  const { callApi } = useApi();
  const { setLoading } = useLoading();
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = parseInt(process.env.REACT_APP_USER_PER_PAGE) || 100;
  const [totalUsers, setTotalUsers] = useState(0);
  const navigate = useNavigate();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const params = {
        page: currentPage,
        length: usersPerPage,
        keyword: searchQuery || undefined,
      };
      const response = await callApi({ endpoint: "/admin/generate-admin", params });
      setUsers(response.data.admins || []);
      setTotalUsers(response.data.total || 0);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [currentPage, searchQuery]);

  // const editUser = (userId) => {
  //   navigate(`/edit-user/${userId}`);
  // };

  const deleteUser = async (userId) => {
    try {
      setLoading(true);
      await callApi({
        endpoint: "admin/generate-admin/destroy",
        method: "DELETE",
        data: { user_ids: [userId] },
      });
      setUsers((prevUsers) => prevUsers.filter(user => user.user_id !== userId));
      Swal.fire("Deleted!", "User has been deleted.", "success");
    } catch (error) {
      console.error("Error deleting user:", error);
      Swal.fire("Error", "Failed to delete user. Try again later.", "error");
    } finally {
      setLoading(false);
    }
  };

  // Open create modal
const openCreateModal = () => {
  setShowCreateModal(true);
};

// Open edit modal
const editUser = (userId) => {
  setSelectedUserId(userId);
  setShowEditModal(true);
};

  return (
    <MainLayout>
      <div className="inner_full_right_part">
        <div className="row">
          <div className="col-md-12">
            <div className="global_cardbox">
              <div className="global_card_header">
                <div className="row">
                  <div className="col-md-3">
                    <div className="global_head_tag">
                      <span><i className="fa-solid fa-folder-open"></i></span> Browse Users <em>({totalUsers} Users)</em>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="heading_block">
                      <input
                        type="search"
                        placeholder="Search Users"
                        value={searchQuery}
                         autoComplete="abcd"
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="heading_block">
                      <button className="btn btn-primary orange_btn"  onClick={openCreateModal}>
                        <span><i className="fa-solid fa-plus"></i></span> Create User
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="browse_client_holder">
                <UserTable
                  users={users}
                  selectedUsers={selectedUsers}
                  editUser={editUser}
                  deleteUser={deleteUser}
                />
                <ClientPagination
                  currentPage={currentPage}
                  totalPages={Math.ceil(totalUsers / usersPerPage)}
                  setCurrentPage={setCurrentPage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <ConfirmPasswordModal
        show={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
      />


<CreateUserModal show={showCreateModal} onClose={() => setShowCreateModal(false)} fetchUsers={fetchUsers} />
<EditUserModal show={showEditModal} onClose={() => setShowEditModal(false)} userId={selectedUserId} fetchUsers={fetchUsers} />
    </MainLayout>
  );
};

export default BrowseUsers;
